:host,
:root {
  /**
   * @prop --c-table-border-color: Table border color
   * @prop --c-table-header-text-color: Table header text color
   * @prop --c-table-row-background-color-mobile: Background color for table rows (even) in mobile
   */
  --_c-table-border-color: var(--c-table-border-color, var(--c-tertiary-200));
  --_c-table-header-text-color: var(--c-table-header-text-color, var(--c-text-system));
  --_c-table-row-background-color-mobile: var(--c-table-row-background-color-mobile, rgba(var(--c-primary-rgb), 0.05));
}

table.c-table {
  border-collapse: collapse;
  border-spacing: 0;
  border: 0;
  font-size: 100%;
  font-family: var(--c-font-family);
  margin: 0;
  padding: 0;
  width: 100%;

  slot {
    display: table;
  }

  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td {
    border: 0;
    font-size: 100%;
    font-family: var(--c-font-family);
    margin: 0;
    padding: 0;
  }

  thead {
    background-color: var(--c-white);
    position: relative;

    th {
      border-bottom: 2px solid var(--_c-table-border-color);
      text-align: left;
    }
  }

  tbody {
    box-shadow: inset 1px 0 0 0 var(--_c-table-border-color),
      inset -1px 0 0 0 var(--_c-table-border-color),
      inset 0 1px 0 0 var(--_c-table-border-color),
      inset 0 -1px 0 0 var(--_c-table-border-color);

    /* Safari box shadow replacement */
    @supports (-webkit-hyphens: none) {
      border: 1px solid var(--_c-table-border-color);

      tr {
        border-bottom: 1px solid var(--_c-table-border-color);
      }
    }

    tr {
      box-shadow: inset 0 1px 0 0 var(--_c-table-border-color);
    }
  }

  tfoot {
    background-color: var(--c-white);

    tr {
      box-shadow: inset 0 1px 0 0 var(--_c-table-border-color);
    }

    td {
      min-height: 48px;

      c-pagination {
        flex: 1;
      }
    }
  }

  th,
  td {
    font-weight: 400;
    box-sizing: border-box;
    line-height: normal;
    padding: 16px;
  }

  th {
    height: 48px;
    font-size: 14px;
    color: var(--_c-table-header-text-color);
  }

  td {
    font-size: 16px;
    color: var(--c-text-body);

    span.c-table__mobile-label {
      display: none;
    }
  }

  &--mobile {
    border-spacing: 0 16px;
    border-collapse: separate;

    tbody {
      box-shadow: none;

      tr {
        border-radius: 4px;
        box-shadow: inset 0 0 0 1px var(--_c-table-border-color);

        /* Safari box shadow replacement */
        @supports (-webkit-hyphens: none) {
          display: grid;
          margin-bottom: 16px;
          border: none;
        }
      }
    }

    thead {
      display: none;
    }

    td {
      display: grid;
      gap: 4px;
      padding: 12px;
      min-height: 48px;

      span.c-table__mobile-label {
        font-size: 14px;
        color: var(--_c-table-header-text-color);
        display: inline-block;
        text-align: start;
        padding-right: 8px;
      }

      &:nth-of-type(even) {
        background-color: var(--_c-table-row-background-color-mobile);
      }
    }
  }
}
